export default "__VITE_ASSET__Zg9lzVNh__"